import {
  AfterViewChecked,
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  OnChanges,
  Renderer2,
  RendererFactory2,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'atx-svg-viewer',
  templateUrl: './svg-viewer.component.html',
  styleUrls: ['./svg-viewer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SvgViewerComponent
  implements AfterViewInit, OnChanges, AfterViewChecked
{
  @Input() public svg: string;
  @ViewChild('svgContainer', { static: false }) public svgContainer: ElementRef;
  private readonly renderer: Renderer2;
  private updateSvgStylingNeeded = false;

  constructor(rendererFactory: RendererFactory2) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  public ngAfterViewChecked(): void {
    if (this.updateSvgStylingNeeded) {
      this.updateSvgStylingNeeded = false;
      this.updateSvgStyles();
    }
  }

  public ngAfterViewInit(): void {
    this.updateSvgStyles();
  }

  public ngOnChanges(): void {
    this.updateSvgStylingNeeded = true;
  }

  private updateSvgStyles(): void {
    if (this.svgContainer && this.svg) {
      let svgElement = this.getSvgElement();
      this.renderer.setProperty(svgElement, 'outerHTML', this.svg);
      svgElement = this.getSvgElement();

      if (svgElement) {
        const widthKey: keyof SVGElement['style'] = 'width';
        const height: keyof SVGElement['style'] = 'height';
        this.renderer.setStyle(svgElement, widthKey, '100%');
        this.renderer.setStyle(svgElement, height, '100%');
      }
    }
  }

  private getSvgElement(): SVGElement {
    return this.svgContainer.nativeElement.querySelector('svg') as SVGElement;
  }
}
